<section class="h-full flex flex-col ">
  <app-modal-header [title]="'Example for: ' + data.computation.name" (onClose)="dialogRef.close()"></app-modal-header>

  <mat-dialog-content>

    <div class="mb-5">
      {{data.computation.description}}
    </div>

    <div [ngSwitch]="data.computation.id">
<!--      &lt;!&ndash; Constant &ndash;&gt;-->

      <!-- Make id -->
      <div *ngSwitchCase="'makeId'">
        <h3 class="heading-sub mb-2">⚙️ Parameters</h3>
        <p class="mb-2">
          This transformation generates a random ID.
          <br>
          It does <strong>not require any inputs</strong>, but you must define the desired length.
        </p>

        <h3 class="heading-sub mb-2 mt-4">🎯 Output examples</h3>
        <ul class="list-disc pl-6 text-sm text-gray-700">
          <li>k5Djft3dDkk9u4nR5ja</li>
          <li>j5gAedm</li>
          <li>592GtqBKExU8a</li>
        </ul>

        <p class="mt-3 text-sm text-gray-500">
          IDs will contain lowercase and uppercase letters, and numbers.
        </p>
      </div>

      <!-- Max -->
      <div *ngSwitchCase="'max'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2">53</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 2</td>
            <td class="py-1 px-2">50</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 3</td>
            <td class="py-1 px-2">61</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation returns the <strong>highest numeric value</strong> from the list.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>61</code>
        </div>
      </div>

      <!-- Min -->
      <div *ngSwitchCase="'min'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2">53</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 2</td>
            <td class="py-1 px-2">50</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 3</td>
            <td class="py-1 px-2">61</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation returns the <strong>lowest numeric value</strong> from the list.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>50</code>
        </div>
      </div>

      <!-- Priority -->
      <div *ngSwitchCase="'priority'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2 text-gray-400">null</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 2</td>
            <td class="py-1 px-2">50</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 3</td>
            <td class="py-1 px-2">61</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation returns the <strong>first non-empty value</strong> in the list.
          <br>
          <span class="text-sm text-gray-500">("Empty" means: <code>null</code> or <code>undefined</code>)</span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>50</code>
        </div>
      </div>

      <!-- Join inputs -->
      <div *ngSwitchCase="'joinInputs'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr><td class="py-1 px-2">Input 1</td><td class="py-1 px-2">55</td></tr>
          <tr><td class="py-1 px-2">Input 2</td><td class="py-1 px-2">50</td></tr>
          <tr><td class="py-1 px-2">Input 3</td><td class="py-1 px-2">61</td></tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation joins all input values into a single string using the separator you define.
          <br>
          <span class="text-sm text-gray-500">In this case, the separator is: <code> - </code></span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>55 - 50 - 61</code>
        </div>
      </div>

      <!-- Most frequent -->
      <div *ngSwitchCase="'mostFrequent'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr><td class="py-1 px-2">Input 1</td><td class="py-1 px-2">50</td></tr>
          <tr><td class="py-1 px-2">Input 2</td><td class="py-1 px-2">55</td></tr>
          <tr><td class="py-1 px-2">Input 3</td><td class="py-1 px-2">50</td></tr>
          <tr><td class="py-1 px-2">Input 4</td><td class="py-1 px-2">61</td></tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation returns the <strong>most frequent value</strong> from the list.
          <br>
          In this case, <code>50</code> appears twice — more than any other value — so it's selected.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>50</code>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If there's no single most frequent value (e.g. a tie), the first one according to the input order will be returned.
        </p>
      </div>

      <!-- Least frequent -->
      <!-- Least frequent -->
      <div *ngSwitchCase="'leastFrequent'">
        <h3 class="heading-sub mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr><td class="py-1 px-2">Input 1</td><td class="py-1 px-2">50</td></tr>
          <tr><td class="py-1 px-2">Input 2</td><td class="py-1 px-2">55</td></tr>
          <tr><td class="py-1 px-2">Input 3</td><td class="py-1 px-2">50</td></tr>
          <tr><td class="py-1 px-2">Input 4</td><td class="py-1 px-2">50</td></tr>
          </tbody>
        </table>

        <p class="mb-2">
          This transformation returns the <strong>least frequent value</strong> from the list.
          <br>
          In this case, <code>55</code> appears only once, while <code>50</code> appears three times — so the result is <strong>55</strong>.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>55</code>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If there's no single least frequent value (e.g. a tie), the first one according to the input order will be returned.
        </p>
      </div>

      <!-- Join -->
      <div *ngSwitchCase="'join'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects an <strong>array</strong> as the input value.</p>

        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2"><code>['tech', 'google cloud', 'payments']</code></td>
          </tr>
          </tbody>
        </table>

        <p class="mb-2">
          It joins all elements into a single string using your selected separator.
          <br>
          <span class="text-sm text-gray-500">Separator used: <code> - </code></span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>tech - google cloud - payments</code>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If the input is not an array, this transformation won’t work as expected.
        </p>
      </div>

      <!-- Split -->
      <div *ngSwitchCase="'split'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects a <strong>string</strong> input, and splits it based on a given separator.</p>

        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2">Request - Website - Any form name here</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-2">
          Using separator: <code> - </code><br>
          Using index: <code>1</code>
        </p>

        <p class="mb-2">This will split the string and return the item at index <code>1</code> of the resulting array.</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>Website</code>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If no index is provided, the full array will be returned.
        </p>
      </div>

      <!-- Stringify -->
      <div *ngSwitchCase="'stringify'">
        <h3 class="heading-sub mb-2">🔄 Convert to string</h3>
        <p class="mb-2">
          This transformation converts any input value into a string using JavaScript’s <code>.toString()</code> method.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Example:</strong> <code>123 → "123"</code>
        </div>
      </div>

      <!-- Item in list -->
      <div *ngSwitchCase="'itemInList'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects an <strong>array of objects</strong> as the input value.</p>

        <app-pretty-print-json [object]="itemInList"></app-pretty-print-json>

        <p class="mb-2">
          It will search for the first object where a given key matches a specific value.
          <br>
          <span class="text-sm text-gray-500">Key: <code>datapoint</code> — Value: <code>website</code></span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="itemInList[2]"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If no object matches the condition, no value will be returned.
        </p>
      </div>

      <!-- nth array item -->
      <div *ngSwitchCase="'nthArrayItem'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects an <strong>array</strong> as the input value.</p>

        <app-pretty-print-json [object]="itemInList"></app-pretty-print-json>

        <p class="mb-2">
          It returns the element at the specified index from the array.
          <br>
          <span class="text-sm text-gray-500">Index used: <code>1</code> (zero-based)</span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="itemInList[1]"></app-pretty-print-json>
        </div>
      </div>

      <!-- Find first occurrence -->
      <div *ngSwitchCase="'findFirstOccurrence'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects an <strong>array of strings</strong> as the input value.</p>

        <app-pretty-print-json [object]="['tag 1', 'tag 4', 'tag 5', 'tag 8', 'tag 11']"></app-pretty-print-json>

        <p class="mt-3 mb-2">
          It checks which values from this list are also present in your configured lookup list:
        </p>
        <app-pretty-print-json [object]="['tag 3', 'tag 5', 'tag 8', 'tag 12']"></app-pretty-print-json>

        <p class="mb-2">
          It returns the <strong>first match</strong> it finds. In this case, that’s:
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>tag 8</code>
        </div>
      </div>

      <!-- Extract URL param -->
      <div *ngSwitchCase="'extractUrlParam'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects a <strong>URL string</strong> as the input.</p>

        <app-pretty-print-json [object]="'https://datamorf.io/some-form-page?utm_campaign=campaign-1&utm_medium=email&some_other_param=some_value'"></app-pretty-print-json>

        <p class="mt-3 mb-2">
          It extracts the value of the specified URL parameter.
          <br>
          <span class="text-sm text-gray-500">Parameter used: <code>utm_campaign</code></span>
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong> <code>campaign-1</code>
        </div>

        <p class="text-sm text-gray-400 mt-3">
          Note: If the string isn’t a valid URL or the parameter doesn’t exist, it won’t return a value.
        </p>
      </div>

      <!-- URL Encode -->
      <div *ngSwitchCase="'encodeURI'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects a <strong>string</strong> input that may contain special characters.</p>

        <app-pretty-print-json [object]="'This string contains spëcial châracters'"></app-pretty-print-json>

        <p class="mt-3 mb-2">
          It encodes the string using <code>encodeURIComponent</code> so it can be safely included in a URL.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'This%20string%20contains%20sp%C3%ABcial%20ch%C3%A2racters'"></app-pretty-print-json>
        </div>
      </div>

      <!-- URL decode -->
      <div *ngSwitchCase="'decodeURI'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation expects a <strong>URL-encoded string</strong> as input.</p>

        <app-pretty-print-json [object]="'This%20string%20contains%20sp%C3%ABcial%20ch%C3%A2racters'"></app-pretty-print-json>

        <p class="mt-3 mb-2">
          It decodes special characters using <code>decodeURIComponent</code>.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'This string contains spëcial châracters'"></app-pretty-print-json>
        </div>
      </div>

      <!-- To lower -->
      <div *ngSwitchCase="'toLower'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to lowercase.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It applies <code>.toLowerCase()</code> to the input string.</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'the brown fox jumps over the lazy dog'"></app-pretty-print-json>

        </div>
      </div>

      <!-- To upper -->
      <div *ngSwitchCase="'toUpper'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to uppercase.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It applies <code>.toUpperCase()</code> to the input string.</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'THE BROWN FOX JUMPS OVER THE LAZY DOG'"></app-pretty-print-json>
        </div>
      </div>

      <!-- To title -->
      <div *ngSwitchCase="'toTitle'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to title case (each word capitalized).</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It applies title casing to every word in the string:</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'The Brown Fox Jumps Over The Lazy Dog'"></app-pretty-print-json>
        </div>
      </div>

      <!-- To snake -->
      <div *ngSwitchCase="'toSnake'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to <code>snake_case</code>.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It replaces spaces with underscores and lowercases the result:</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'the_brown_fox_jumps_over_the_lazy_dog'"></app-pretty-print-json>
        </div>
      </div>

      <!-- To kebab -->
      <div *ngSwitchCase="'toKebab'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to <code>kebab-case</code>.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It replaces spaces with hyphens and lowercases the result:</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'the-brown-fox-jumps-over-the-lazy-dog'"></app-pretty-print-json>
        </div>
      </div>

      <!-- To camel -->
      <div *ngSwitchCase="'toCamel'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation converts a <strong>string</strong> to <code>camelCase</code>.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">It removes spaces and capitalizes each word except the first:</p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'theBrownFoxJumpsOverTheLazyDog'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Wrap -->
      <div *ngSwitchCase="'wrapString'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation adds a prefix and suffix to a string.</p>

        <app-pretty-print-json [object]="'The brown FOX jumps over the lazy DOG'"></app-pretty-print-json>

        <p class="mt-3 mb-2">
          With these parameters:
        </p>
        <ul class="list-disc pl-6 text-sm text-gray-700 mb-2">
          <li><strong>Leading wrap:</strong> <code>[</code></li>
          <li><strong>Trailing wrap:</strong> <code>]</code></li>
        </ul>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'[The brown FOX jumps over the lazy DOG]'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Execution id -->
      <div *ngSwitchCase="'executionId'">
        <h3 class="heading-sub mb-2">🔗 No input required</h3>
        <p class="mb-2">
          This transformation returns the <strong>unique ID of the current workflow execution</strong>.
          Useful for logging, debugging, or traceability.
        </p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="executionId"></app-pretty-print-json>
        </div>
      </div>

      <!-- Dictionary -->
      <div *ngSwitchCase="'dictionary'">
        <h3 class="heading-sub mb-2">🧪 Example input</h3>
        <p class="mb-2">This transformation maps a string to a custom dictionary of values.</p>

        <app-pretty-print-json [object]="'key-3'"></app-pretty-print-json>

        <p class="mt-3 mb-2">Using this dictionary table:</p>

        <table class="table-auto w-full shadow rounded mb-4 text-sm">
          <thead class="border-b text-left text-gray-600 bg-gray-50">
          <tr>
            <th class="p-1">Key</th>
            <th class="p-1">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr><td class="p-1">key-1</td><td class="p-1">Value 1</td></tr>
          <tr><td class="p-1">key-2</td><td class="p-1">Value 2</td></tr>
          <tr class="bg-green-50 font-semibold"><td class="p-1">key-3</td><td class="p-1">Value 3</td></tr>
          <tr><td class="p-1">key-4</td><td class="p-1">Value 4</td></tr>
          </tbody>
        </table>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'Value 3'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Sort list -->
      <div *ngSwitchCase="'sortList'">
        <p class="mb-2">This transformation expects a list as input. It can be a list of strings, numbers, or objects.</p>

        <h3 class="heading-sub mt-5 mb-2">🔁 Example 1: Sort a list of objects by timestamp</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="list"></app-pretty-print-json>

        <ul class="list-disc pl-4 mt-3 mb-2 text-sm">
          <li>Sort using property: <code>timestamp</code></li>
          <li>Sort direction: <code>descendant</code></li>
          <li>Pick element at index: <code>0</code></li>
          <li>Return property: <code>listId</code></li>
        </ul>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mb-5">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="1440"></app-pretty-print-json>
        </div>

        <h3 class="heading-sub mt-8 mb-2">🔤 Example 2: Sort a list of strings</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="list2"></app-pretty-print-json>

        <ul class="list-disc pl-4 mt-3 mb-2 text-sm">
          <li>No sorting property</li>
          <li>Sort direction: <code>ascendant</code> (A → Z)</li>
          <li>Pick element at index: <code>1</code></li>
        </ul>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'Apple'"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-4">
          ⚠️ Note: If the input list contains objects, you must provide a <code>sorting property</code> — otherwise sorting might not work as expected.
        </p>
      </div>

      <!-- Dot notation path -->
      <div *ngSwitchCase="'path'">
        <p class="mb-2">This transformation expects an object as input and lets you extract nested values using a dot notation path.</p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="object"></app-pretty-print-json>

        <p class="mb-1">Using path: <code>user.name.first</code></p>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'John'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Make array with inputs -->
      <div *ngSwitchCase="'makeArrayWithInputs'">
        <p class="mb-2">This transformation combines multiple input values into a single array.</p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example inputs</h3>
        <table class="w-full text-sm table-auto mb-3">
          <thead class="text-left text-gray-500 border-b">
          <tr>
            <th class="py-1 px-2">Input</th>
            <th class="py-1 px-2">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="py-1 px-2">Input 1</td>
            <td class="py-1 px-2">John</td>
          </tr>
          <tr>
            <td class="py-1 px-2">Input 2</td>
            <td class="py-1 px-2">Doe</td>
          </tr>
          </tbody>
        </table>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="['John', 'Doe']"></app-pretty-print-json>
        </div>
      </div>

      <!-- Extract property from array of objects -->
      <div *ngSwitchCase="'extractPropertyFromArrayOfObjects'">
        <p class="mb-2">This transformation takes a list of objects and extracts the value of a given property from each one.</p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example input</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="list"></app-pretty-print-json>

        <p class="mb-1">Using property path: <code>listId</code></p>

        <div class="p-3 mt-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="[1574, 504, 1440, 354]"></app-pretty-print-json>
        </div>
      </div>

      <!-- GPT Prompt -->
      <div *ngSwitchCase="'gptPrompt'">
        <p class="mb-2">
          This transformation sends a custom prompt to GPT and returns the result. Please consider using the new GPT Response transformation instead.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🛠️ How to use it</h3>
        <p class="mb-1">
          Write your prompt in the text box. You can include dynamic variables by clicking the <code>fx</code> button and selecting previous transformation results.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>
        <p class="mb-1">Example values from previous transformations:</p>
        <table class="basic-table text-sm text-left mb-5">
          <thead>
          <tr>
            <th>Transformation name</th>
            <th>Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="font-light">First Name</td>
            <td class="font-light text-right">John</td>
          </tr>
          <tr>
            <td class="font-light">Location</td>
            <td class="font-light text-right">Barcelona</td>
          </tr>
          <tr>
            <td class="font-light">Company Name</td>
            <td class="font-light text-right">Datamorf</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-1">Prompt (before substitution):</p>
        <div ngNonBindable class="bg-gray-50 rounded p-2 mb-3 text-sm">
          Hey GPT, complete the following sentence including a fun fact about the city:<br>
          Hey <span class="interpolation">First Name</span>!<br>
          I've recently visited <span class="interpolation">Location</span> and I realised your company <span class="interpolation">Company Name</span> is based there. It was very interesting because...
        </div>

        <p class="mb-1">Final prompt (after variable substitution):</p>
        <div ngNonBindable class="bg-gray-50 rounded p-2 mb-3 text-sm">
          Hey GPT, complete the following sentence including a fun fact about the city:<br>
          Hey John!<br>
          I've recently visited Barcelona and I realised your company Datamorf is based there. It was very interesting because...
        </div>

        <p class="mb-1">
          GPT will return a result based on the prompt. Outputs can vary depending on the language and style you choose.
        </p>

        <p class="text-sm text-gray-400 mt-4">
          Note: if a referenced variable is not found, it will be skipped in the final prompt.
        </p>
      </div>

      <!-- GPT Response -->
      <div *ngSwitchCase="'gptResponse'">
        <p class="mb-2">
          This transformation sends a custom prompt to GPT and returns the result. This transformation uses the Responses API from OpenAI, which has more capabilities than the old Chat Completions API.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🛠️ How to use it</h3>
        <p class="mb-1">
          Write your prompt in the text box. You can include dynamic variables by typing <code>@</code> and selecting any previous workflow value (incoming data, transformations, sources...).
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>
        <p class="mb-1">Example values from previous transformations:</p>
        <table class="basic-table text-sm text-left mb-5">
          <thead>
          <tr>
            <th>Transformation name</th>
            <th>Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="font-light">First Name</td>
            <td class="font-light text-right">John</td>
          </tr>
          <tr>
            <td class="font-light">Location</td>
            <td class="font-light text-right">Barcelona</td>
          </tr>
          <tr>
            <td class="font-light">Company Name</td>
            <td class="font-light text-right">Datamorf</td>
          </tr>
          </tbody>
        </table>

        <p class="mb-1">Prompt (before substitution):</p>
        <div ngNonBindable class="bg-gray-50 rounded p-2 mb-3 text-sm">
          Hey GPT, complete the following sentence including a fun fact about the city:<br>
          Hey <span class="interpolation">First Name</span>!<br>
          I've recently visited <span class="interpolation">Location</span> and I realised your company <span class="interpolation">Company Name</span> is based there. It was very interesting because...
        </div>

        <p class="mb-1">Final prompt (after variable substitution):</p>
        <div ngNonBindable class="bg-gray-50 rounded p-2 mb-3 text-sm">
          Hey GPT, complete the following sentence including a fun fact about the city:<br>
          Hey John!<br>
          I've recently visited Barcelona and I realised your company Datamorf is based there. It was very interesting because...
        </div>

        <p class="mb-1">
          GPT will return a result based on the prompt. Outputs can vary depending on the language and style you choose.
        </p>

        <p class="text-sm text-gray-400 mt-4">
          Note: You can reference files/images and tweak other prompt settings in the <strong>Other configurations</strong> section at the bottom of the transformation editor.
        </p>
        <p class="text-sm text-gray-400 mt-4">
          Note 2: if a referenced variable is not found, it will be skipped in the final prompt.
        </p>
      </div>

      <!-- Extract domain from an email -->
      <div *ngSwitchCase="'extractEmailDomain'">
        <p class="mb-2">
          This transformation extracts the domain part of an email address.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'info@datamorf.io'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'datamorf.io'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Extract name from an email -->
      <div *ngSwitchCase="'extractEmailName'">
        <p class="mb-2">
          This transformation extracts the name part (before <code>&#64;</code>) from an email address.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'info@datamorf.io'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'info'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Get domain name -->
      <div *ngSwitchCase="'getDomainName'">
        <p class="mb-2">
          This transformation extracts the root domain from a full URL.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.datamorf.io/guides/get-started?utm_medium=email'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'datamorf.io'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Get top level domain -->
      <div *ngSwitchCase="'getTopLevelDomain'">
        <p class="mb-2">
          This transformation extracts the top-level domain (TLD) from a full URL (e.g. <code>.com</code>, <code>.io</code>, etc).
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.datamorf.io/guides/get-started?utm_medium=email'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'io'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Get second level domain -->
      <div *ngSwitchCase="'getSecondLevelDomain'">
        <p class="mb-2">
          This transformation extracts the second-level domain (SLD), which is the name before the top-level domain.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.datamorf.io/guides/get-started?utm_medium=email'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'datamorf'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Get host name -->
      <div *ngSwitchCase="'getHostName'">
        <p class="mb-2">
          This transformation extracts the full hostname from a given URL.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.datamorf.io/guides/get-started?utm_medium=email'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'www.datamorf.io'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Get LinkedIn handle -->
      <div *ngSwitchCase="'getLinkedinHandle'">
        <p class="mb-2">
          This transformation extracts the LinkedIn handle from a person or company profile URL.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example — Person URL</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.linkedin.com/in/john-doe-123456/'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'john-doe-123456'"></app-pretty-print-json>
        </div>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example — Company URL</h3>

        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'https://www.linkedin.com/company/datamorf2/'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'datamorf2'"></app-pretty-print-json>
        </div>
      </div>

      <!-- Is valid email -->
      <div *ngSwitchCase="'isValidEmail'">
        <p class="mb-2">
          This transformation checks if the input is a valid email address using a basic format validation.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input:</p>
        <app-pretty-print-json [object]="'info@datamorf.io'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="true"></app-pretty-print-json>
        </div>

        <p class="mb-3 mt-5">Another example with invalid formatting:</p>
        <app-pretty-print-json [object]="'2info@datamorf.io'"></app-pretty-print-json>

        <div class="p-3 bg-red-100 text-red-800 rounded border border-red-300 text-sm mt-3">
          ❌ <strong>Result:</strong>
          <app-pretty-print-json [object]="false"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-4">Note: this only checks format, not actual email existence.</p>
      </div>

      <!-- Is valid domain -->
      <div *ngSwitchCase="'isValidDomain'">
        <p class="mb-2">
          This transformation checks if the input is a valid domain format (e.g. <code>example.com</code>).
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example</h3>

        <p class="mb-1">Input:</p>
        <app-pretty-print-json [object]="'DATAMORF.IO'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="true"></app-pretty-print-json>
        </div>

        <p class="mb-3 mt-5">Another example with invalid format:</p>
        <app-pretty-print-json [object]="'datamorf.io ltd'"></app-pretty-print-json>

        <div class="p-3 bg-red-100 text-red-800 rounded border border-red-300 text-sm mt-3">
          ❌ <strong>Result:</strong>
          <app-pretty-print-json [object]="false"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-4">Note: this only validates format, not whether the domain exists or is reachable.</p>
      </div>

      <!-- Stop Execution -->
      <div *ngSwitchCase="'stopExecution'">
        <p class="mb-2">
          This transformation will <strong>immediately stop</strong> the execution of the workflow. Nothing beyond this point will run.
        </p>

        <h3 class="heading-sub mt-5 mb-2">⚠️ Important</h3>
        <p class="mb-2">
          By default, this transformation always stops the workflow. If you want to stop it only under certain conditions, you should activate the
          <strong>conditional toggle</strong> and define your logic there.
        </p>

        <h3 class="heading-sub mt-5 mb-2">💡 Example use case</h3>
        <p class="mb-1">Let’s say you only want to stop the workflow if the lead's email is from a free provider (like gmail.com):</p>

        <ul class="list-disc pl-6 mb-2">
          <li>Add a condition: <code>email_domain equals gmail.com</code></li>
          <li>If true → this transformation is triggered → workflow stops</li>
          <li>If false → workflow continues as usual</li>
        </ul>

        <div class="p-3 bg-yellow-100 text-yellow-800 rounded border border-yellow-300 text-sm mt-3">
          ⚠️ This transformation doesn't return a value — it simply stops everything.
        </div>

        <p class="text-sm text-gray-400 mt-4">
          Use this with caution — when triggered, no further steps in the workflow will run.
        </p>
      </div>

      <!-- Get Size -->
      <div *ngSwitchCase="'getSize'">
        <p class="mb-2">
          This transformation returns the <strong>size</strong> of the input. It works with strings, arrays, and objects.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example 1: String input</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'hello world'"></app-pretty-print-json>

        <p class="mb-1">Result:</p>
        <app-pretty-print-json [object]="11"></app-pretty-print-json>
        <p class="text-sm text-gray-400 mb-4">Counts characters, including spaces.</p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example 2: Array input</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="['apple', 'banana', 'cherry']"></app-pretty-print-json>

        <p class="mb-1">Result:</p>
        <app-pretty-print-json [object]="3"></app-pretty-print-json>
        <p class="text-sm text-gray-400 mb-4">Counts how many items are in the array.</p>

        <h3 class="heading-sub mt-5 mb-2">🧪 Example 3: Object input</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="{ name: 'Alice', city: 'Barcelona', age: 30 }"></app-pretty-print-json>

        <p class="mb-1">Result:</p>
        <app-pretty-print-json [object]="3"></app-pretty-print-json>
        <p class="empty-hint">Counts how many keys the object has.</p>
      </div>

      <!-- Name normalizer -->
      <div *ngSwitchCase="'normalizer'">
        <p class="mb-1">
          This transformation uses AI to clean and standardize a single type of name: either a person’s name, a company name, or a job title. You must choose one type per transformation.
        </p>

        <h3 class="heading-sub mt-5 mb-2">👤 Example: Person Name</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'mr. jOhN   doE 👨‍💼'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'John Doe'"></app-pretty-print-json>
        </div>

        <h3 class="heading-sub mt-5 mb-2">🏢 Example: Company Name</h3>
        <p class="mb-1">Input value:</p>
        <app-pretty-print-json [object]="'DATAMORF.io S.L.'"></app-pretty-print-json>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result:</strong>
          <app-pretty-print-json [object]="'Datamorf'"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-4">
          Note: If you want to normalize more than one type (e.g. name and job title), use multiple transformations with different configurations.
        </p>
      </div>

      <!-- Random selection -->
      <div *ngSwitchCase="'randomSelection'">
        <p class="mb-1">
          This transformation takes multiple input values and randomly selects one. Every value has an equal probability of being picked.
        </p>

        <h3 class="heading-sub mt-5 mb-2">🎲 Example</h3>

        <p class="mb-1">Input values:</p>
        <ul class="list-disc pl-6 mb-3">
          <li><code>'apple'</code></li>
          <li><code>'banana'</code></li>
          <li><code>'cherry'</code></li>
        </ul>

        <div class="p-3 bg-green-100 text-green-800 rounded border border-green-300 text-sm mt-3">
          ✅ <strong>Result (random):</strong>
          <app-pretty-print-json [object]="'banana'"></app-pretty-print-json>
        </div>

        <p class="text-sm text-gray-400 mt-4">
          Note: Results will change every execution — it’s random.
        </p>
      </div>

      <div *ngSwitchDefault class="empty-hint">
        This computation doesn't have any example yet. We are working hard to have a good documentation. Sorry for the inconvenience.
      </div>
    </div>

  </mat-dialog-content>
</section>
